import React, { useState } from "react"
import { AiOutlineClose } from "react-icons/ai"
import { Link } from "react-router-dom"
import { useToasts } from "react-toast-notifications"
import { addCoCelebrant } from "../../utils/ApiRequests"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import InputField from "../InputField/InputField"
import FullLoader from "../Loaders/FullLoader"
import ModalContainer from "../ModalContainer/ModalContainer"

const DashboardSteps = ({ step1, step2, step3, step4, step5, registryId }) => {
  const registry = registryId?.length ? registryId[0] : ""
  const [addCoSabi, setAddCoSabi] = useState(false)
  const [manageEvent, setManageEvent] = useState(false)
  const [coForm, setCoForm] = useState({})
  const [loading, setLoading] = useState(false)
  const { addToast } = useToasts()

  const handleCoForm = e => {
    const name = e.target.name
    const value = e.target.value
    const newEntry = { [name]: value }
    setCoForm({ ...coForm, ...newEntry })
  }

  const addCoSabiCelebrant = e => {
    e.preventDefault()
    setLoading(true)
    addCoCelebrant(registry, coForm)
      .then(res => {
        addToast(res?.data?.message, { appearance: "success" })
        setLoading(false)
        setAddCoSabi(false)
      })
      .catch(err => {
        addToast(getApiErrorMessage(err?.response), { appearance: "error" })
        setLoading(false)
      })
  }

  return (
    <>
      <p className="mt-10 font-medium text-lg">Next steps to take</p>
      {addCoSabi && (
        <ModalContainer>
          <div className="pb-7 pt-3 bg-white px-5 w-96">
            <AiOutlineClose
              className="text-2xl ml-auto mb-4 cursor-pointer"
              onClick={() => setAddCoSabi(false)}
            />
            <h2 className="text-center text-sbg-grey text-xl mb-5">
              Add Co Sabi Celebrant
            </h2>
            {loading && <FullLoader />}
            <form
              action=""
              className="flex justify-center flex-col"
              onSubmit={addCoSabiCelebrant}
            >
              <InputField
                type="email"
                placeholder="Email Address"
                label="Email Address"
                required
                name="email"
                handleChange={handleCoForm}
              />
              <button
                type="submit"
                className="mx-auto px-5 inline-block py-2 text-center text-white bg-sbg-light-green font-medium text-base focus:outline-none"
              >
                Add Celebrant
              </button>
            </form>
          </div>
        </ModalContainer>
      )}
      {manageEvent && (
        <ModalContainer>
          <div className="w-96 py-7 bg-white px-5 ">
            <AiOutlineClose className="text-xl" />
            <h2 className="text-center text-sbg-grey text-xl mb-5">
              Add Co Sabi Celebrant
            </h2>
            <form action="" className="flex justify-center flex-col">
              <InputField
                type="email"
                placeholder="Email Address"
                label="Email Address"
              />
              <button
                type="submit"
                className="mx-auto px-5 inline-block py-2 text-center text-white bg-sbg-light-green font-medium text-xl focus:outline-none"
              >
                Add Celebrant
              </button>
            </form>
          </div>
        </ModalContainer>
      )}
      <div className="overflow-auto whitespace-nowrap py-5 bg-sbg-white hide-scrollbar">
        {!step1 && (
          <div
            className="h-60 w-60 rounded-3xl shadow-lg mr-5 p-5 inline-block relative "
            onClick={() => {
              window.scrollTo({ top: 1138, left: 0, behavior: "smooth" })
            }}
          >
            <div className="flex-col flex justify-between h-full">
              <img
                src={require("../../assets/notification.svg").default}
                alt="notification"
                className="h-8 self-start"
              />
              <img
                src={require("../../assets/presents.svg").default}
                alt="presents"
                className="self-center h-3/6"
              />
              <h1 className="">
                {/* <p className="mt-1">1</p> */}
                <p className="mt-1">Add Items to registry</p>
              </h1>
            </div>

            <div className="absolute top-auto bottom-10 right-4 bg-sbg-light-grey-2 px-2 rounded cursor-pointer">
              +
            </div>
          </div>
        )}

        {!step2 && (
          <div
            className="h-60 w-60 rounded-3xl shadow-lg mr-5 p-5 inline-block relative"
            onClick={() => setAddCoSabi(true)}
          >
            <div className="flex-col flex justify-between h-full">
              <img
                src={require("../../assets/notification.svg").default}
                alt="notification"
                className="h-8 self-start"
              />
              <img
                src={require("../../assets/valentine.svg").default}
                alt="presents"
                className="self-center h-3/6"
              />
              <h1 className="">
                {/* <p className="mt-1">2</p> */}
                <p className="mt-1">Add Co-Sabi Celebrant</p>
              </h1>
            </div>

            <div className="absolute top-auto bottom-10 right-4 bg-sbg-light-grey-2 px-2 rounded cursor-pointer">
              +
            </div>
          </div>
        )}

        {!step3 && (
          <Link
            to="/update-event"
            className="h-60 w-60 rounded-3xl shadow-lg mr-5 p-5 inline-block relative"
          >
            <div className="flex-col flex justify-between h-full">
              <img
                src={require("../../assets/notification.svg").default}
                alt="notification"
                className="h-8 self-start"
              />
              <img
                src={require("../../assets/drinks.svg").default}
                alt="presents"
                className="self-center h-3/6"
              />
              <h1 className="">
                {/* <p className="mt-1">3</p> */}
                <p className="mt-1">Manage Event</p>
              </h1>
            </div>

            <div className="absolute top-auto bottom-10 right-4 bg-sbg-light-grey-2 px-2 rounded cursor-pointer">
              +
            </div>
          </Link>
        )}

        {!step5 && (
          <Link
            className="h-60 w-60 rounded-3xl shadow-lg mr-5 p-5 inline-block relative"
            to={`/registry/${registry}`}
          >
            <div className="flex-col flex justify-between h-full">
              <img
                src={require("../../assets/notification.svg").default}
                alt="notification"
                className="h-8 self-start"
              />
              <img
                src={require("../../assets/monitor.svg").default}
                alt="presents"
                className="self-center h-3/6"
              />
              <h1 className="">
                {/* <p className="mt-1">5</p> */}
                <p className="mt-1">Setup registry page</p>
              </h1>
            </div>

            <div className="absolute top-auto bottom-10 right-4 bg-sbg-light-grey-2 px-2 rounded cursor-pointer">
              +
            </div>
          </Link>
        )}
      </div>
    </>
  )
}

export default DashboardSteps

// {!step4 && (
//   <div className="h-60 w-60 rounded-3xl shadow-lg mr-5 p-5 inline-block relative">
//     <div className="flex-col flex justify-between h-full">
//       <img
//         src={require("../../assets/notification.svg").default}
//         alt="notification"
//         className="h-8 self-start"
//       />
//       <img
//         src={require("../../assets/finance.svg").default}
//         alt="presents"
//         className="self-center h-3/6"
//       />
//       <h1 className="">
//         {/* <p className="mt-1">4</p> */}
//         <p className="mt-1 overflow-x-hidden">
//           Invite people to your event
//         </p>
//       </h1>
//     </div>

//     <div className="absolute top-auto bottom-10 right-4 bg-sbg-light-grey-2 px-2 rounded cursor-pointer">
//       +
//     </div>
//   </div>
// )}
